import { client, previewClient } from './client';
import * as Dom from 'graphql-request/dist/types.dom';
import { GraphQLError, GraphQLResponse } from 'graphql-request/dist/types';
import { ClientError } from 'graphql-request';
import { sendMetric } from '../../../../features/src/metrics';
import { MetricTypes } from '@spotify-internal/semantic-metrics';

export const getClient = (preview: boolean) =>
  preview ? previewClient : client;

export interface RawContentfulEntry {
  sys: {
    id: string;
  };

  [key: string]: any;
}

export interface ContentfulEntry {
  id: string;
  contentType: string;

  [key: string]: any;
}

export const flattenSys =
  (contentType?: string) =>
  (entry: RawContentfulEntry): ContentfulEntry => ({
    ...entry,
    sys: undefined,
    id: entry.sys.id,
    contentType: contentType || 'unknown',
  });

export interface RawContentfulCollection {
  items: RawContentfulEntry[];
}

export const pickFirst =
  (key: string) => (collection: RawContentfulCollection) => {
    if (!collection?.items?.length) {
      throw new Error(`${key} not found`);
    }
    return collection.items[0];
  };

export interface RawResponse<T> {
  data?: T;
  extensions?: any;
  headers?: Dom.Headers;
  status: number;
  errors?: GraphQLError[];
}

export const QUERY_COST = 'X-Contentful-Graphql-Query-Cost';

export const unwrapClientError = (error: ClientError): GraphQLResponse =>
  error.response;

export const unwrapResponse =
  <T>(key: string) =>
  (response: RawResponse<T>): T => {
    if (response.headers?.has(QUERY_COST)) {
      const queryCost = parseInt(response.headers.get(QUERY_COST)!, 10);
      sendMetric({
        metric_type: MetricTypes.GAUGE,
        what: 's4a-frontdoor-contentful-query-cost',
        value: queryCost,
        tags: {
          pod: 'unknown',
          namespace: 'creator-web-metrics',
        },
      });
    }

    if (response.errors && response.errors.length) {
      throw response.errors[0];
    }

    if (!response.data) {
      throw new Error(`${key} not found`);
    }

    return response.data;
  };
